import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AdaptToolbarModule } from "@common/shell/toolbar/toolbar.module";
import { AdaptAutosaveModule } from "@common/ux/autosave/autosave.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptCollapsibleDashboardElementModule } from "@common/ux/collapsible-dashboard-element/collapsible-dashboard-element.module";
import { AdaptDateModule } from "@common/ux/date/date.module";
import { AdaptEntityValidatorModule } from "@common/ux/entity-validator/entity-validator.module";
import { AdaptHtmlEditorModule } from "@common/ux/html-editor/html-editor.module";
import { AdaptProgressBarModule } from "@common/ux/progress-bar/progress-bar.module";
import { AdaptSeeMoreModule } from "@common/ux/see-more/see-more.module";
import { AdaptStyledDashboardElementModule } from "@common/ux/styled-dashboard-element/styled-dashboard-element.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { DxDataGridModule, DxDateBoxModule, DxScrollViewModule, DxSelectBoxModule, DxSortableModule, DxTagBoxModule, DxTextBoxModule } from "devextreme-angular";
import { CollapseDirective } from "ngx-bootstrap/collapse";
import { EditProgressCategoryComponent } from "./edit-progress-category/edit-progress-category.component";
import { SelectProgressProductsComponent } from "./select-progress-products/select-progress-products.component";


@NgModule({
    declarations: [
        EditProgressCategoryComponent,
        SelectProgressProductsComponent,
    ],
    imports: [
        CommonModule,
        AdaptButtonModule,
        AdaptCollapsibleDashboardElementModule,
        AdaptEntityValidatorModule,
        AdaptHtmlEditorModule,
        AdaptProgressBarModule,
        AdaptSeeMoreModule,
        AdaptStyledDashboardElementModule,
        AdaptToolbarModule,
        AdaptTooltipModule,
        CollapseDirective,
        DxDataGridModule,
        DxDateBoxModule,
        DxSelectBoxModule,
        DxSortableModule,
        DxTextBoxModule,
        DxScrollViewModule,
        DxTagBoxModule,
        AdaptDateModule,
        AdaptAutosaveModule,
    ],
    exports: [
        EditProgressCategoryComponent,
        SelectProgressProductsComponent,
    ],
})
export class AdaptCommonProgressModule {}
